import styled, { css } from 'styled-components'

// Utils
import { breakpoint } from '@sketch/global-styles'

import { skeletonFadeStyles } from '@sketch/components'

export const Title = styled.p<{ $small?: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes.F};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin: ${({ $small }) => ($small ? '0px' : '16px 0 0 0')};

  ${breakpoint('md', 'lg')`
    margin: 0;
  `}

  ${breakpoint('base', 'xs')`
    margin: 0;
  `}


  ${({ $small }) =>
    $small &&
    css`
      ${breakpoint('base', 'sm')`
        display: none;
      `}
    `};
`

export const Description = styled.p<{ $small?: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes.D};
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  margin: ${({ $small }) => ($small ? '0px' : '6px 0 0 0')};

  ${({ $small }) =>
    $small &&
    css`
      ${breakpoint('base', 'sm')`
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
      `}
    `};
`

export const IconContainer = styled.div<{ $small?: boolean }>`
  display: flex;

  width: ${({ $small }) => ($small ? '32px' : '48px')};
  height: ${({ $small }) => ($small ? '32px' : '48px')};
  margin-right: ${({ $small }) => ($small ? '12px' : '0')};
  align-items: flex-start;

  ${breakpoint('base', 'xs')`
    width: 32px;
    height: 32px;
  `}
`

export const BodyContainer = styled.div<{ $small?: boolean }>`
  display: flex;
  flex-direction: ${({ $small }) => ($small ? 'row' : 'column')};
  flex: 1;

  ${breakpoint('md', 'lg')`
    margin-left: 16px;
  `}

  ${breakpoint('base', 'xs')`
    margin-left: 16px;
  `}
`

export const ActionContainer = styled.div<{ $small?: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  justify-content: flex-end;

  ${breakpoint('md', 'lg')`
    align-items: flex-start;
  `}

  ${({ $small }) =>
    $small
      ? css`
          flex: 0 0 auto;
          align-self: center;
          align-items: flex-end;
          margin-left: 16px;
        `
      : css`
          margin-top: 16px;
        `};
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const Wrapper = styled.div<{ $small?: boolean }>`
  ${({ theme, $small }) => css`
    position: relative;

    display: flex;
    flex-direction: ${$small ? 'row' : 'column'};
    flex: 1;
    max-width: 100%;

    padding: ${$small ? '14px 16px' : '24px'};
    border: 1px solid ${theme.colors.border.A};
    border-radius: ${theme.radii.large};

    &:not(:last-child) {
      margin-right: 40px;
    }

    :hover {
      ${Dismiss} {
        opacity: 1;
      }
    }

    ${ActionContainer} {
      flex: 1;
    }

    ${breakpoint('md', 'lg')`
        flex-direction: row;
        flex: 1 1 44%;
        max-width: 100%;
    `}

    ${breakpoint('sm', 'md')`
        flex: 1 1 44%;
        max-width: 100%;
    `}

    ${breakpoint('xs', 'sm')`
        flex: 1 1 44%;
        max-width: 100%;
    `}

    ${breakpoint('base', 'lg')`
        &:not(:last-child) {
          margin-right: 0;
        }

        &:nth-child(n+3) {
          margin-top: 40px;
        }

        &:not(:nth-child(2n)) {
          margin-right: 40px;
        }
    `}

    ${breakpoint('base', 'md')`
      &:nth-child(n+3) {
        margin-top: 16px;
      }

      &:not(:nth-child(2n)) {
        margin-right: 16px;
      }
    `}

    ${breakpoint('base', 'xs')`
        flex-direction: row;
        flex: 1 1 100%;
        max-width: 100%;

        &:not(:first-child) {
          margin-top: 16px;
        }

        &:not(:nth-child(2n)) {
         margin-right: 0;
        }
    `}
  `}
`

export const Action = styled.div<{ $small?: boolean }>`
  display: flex;
  flex-direction: column;

  ${({ $small }) =>
    $small &&
    css`
      align-self: flex-end;

      ${breakpoint('base', 'sm')`
        display: none;
      `}
    `};
`

export const Dismiss = styled.button<{ $small?: boolean }>`
  position: absolute;
  top: -11px;
  right: -11px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  padding: 4px;
  background: ${({ theme }) => theme.colors.background.secondary.A};
  border: 1px solid ${({ theme }) => theme.colors.border.A};
  border-radius: 100%;
  opacity: 0;
  transition: opacity 300ms ease-in-out;
  cursor: pointer;

  ${({ $small }) =>
    $small &&
    css`
      ${breakpoint('base', 'sm')`
          position: relative;
          top: auto;
          right: auto;
          opacity: 1;
        `};
    `};
`

export const BannerCardSkeleton = styled(Wrapper)`
  height: 272px;
  border: 0;

  ${skeletonFadeStyles}
`
